module.exports = __webpack_public_path__ + "img/der_01_robot_body.94b02cd8.gif";